import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usersService } from "../../services/UsersService";
import { Button } from "primereact/button";
import { formatDateTime } from "../../config/Config";
import { changeLang } from "../../componets/Language/ChangeLang";


export const UserDelimitationView = ({ userID }) => {
	const [loading, setLoading] = useState(false);
	var [delimitations, setDelimitations] = useState([]);
	
	useEffect(() => {
		getDelimitations(userID);
		}, [userID]);
		
		
	function getDelimitations(userId) {
		setLoading(true);
		usersService
			.getDelimitations(userId)
			.then((data) => {
				setLoading(false);
				console.log("-----------");
				console.log(data);
			data.forEach(element => {
				if(element.delimitationLevelID === 1)
				{
					element.constituencyName = "All";
					element.pollingDivisionName = "All";
					element.registrationCentreName = "All";
				}
				else if(element.delimitationLevelID === 2)
				{
					element.pollingDivisionName = "All";
					element.registrationCentreName = "All";
				}
				else if(element.delimitationLevelID === 3)
				{
					element.registrationCentreName = "All";
				}
			});
				setDelimitations(data);
			})
			.catch((error) => {
				console.error("Error fetching delimitations:", error);
				setLoading(false);
			});
	}
	return (
		<>
			<DataTable
				size="small"
				scrollable={true}
				value={delimitations}
				dataKey="id"
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
				emptyMessage="No delimitation(s) found."
				resizableColumns
				loading={loading}
			>
				<Column field="districtName" header={changeLang.get("national_delimitation.level1District")}></Column>
				<Column field="constituencyName" header={changeLang.get("national_delimitation.level2ConstituencyCouncil")}></Column>
				<Column field="pollingDivisionName" header={changeLang.get("national_delimitation.level3PollingElectorDivision")}></Column>
				<Column field="registrationCentreName" header={changeLang.get("national_delimitation.level4RegistrationCentre")}></Column>
				<Column 
					header="Assigned By" 
					body={(rowData) => rowData.updater ? rowData.updater : rowData.creater} 
				/>
				<Column 
					header="Assigned Date" 
					body={(rowData) => rowData.updatedDate ? formatDateTime(rowData.updatedDate) : formatDateTime(rowData.createdDate)} 
				/>
			</DataTable>
		</>
	)}